module.exports = __webpack_public_path__ + "img/smart-utilities-depth.975c5d44.png";